import type { SVGProps } from "react";

export function School(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M22 10L12 5 2 10l10 5 10-5z" />
      <path d="M6 12v6" />
      <path d="M18 12v6" />
      <path d="M6 18c4 2 8 2 12 0" />
    </svg>
  );
}
